function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M328.417,208.293l-40-80c-2.541-5.082-7.735-8.292-13.417-8.292c-5.682,0-10.875,3.21-13.416,8.292 l-44.868,89.735L158.98,69.565c-2.181-5.609-7.503-9.371-13.519-9.557c-6.006-0.173-11.559,3.243-14.081,8.708L75.402,190.001H15 c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15h70c5.851,0,11.168-3.402,13.619-8.714l45.201-97.934l57.2,147.085 c2.15,5.53,7.358,9.273,13.285,9.547c0.233,0.011,0.466,0.016,0.699,0.016c5.659,0,10.864-3.194,13.413-8.292L275,168.542 l26.584,53.167c3.705,7.41,12.716,10.414,20.124,6.708C329.118,224.713,332.121,215.703,328.417,208.293z"
});

var SvgPulse = function SvgPulse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-pulse",
    viewBox: "0 0 330.003 330.003",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPulse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pulse.7215b022.svg";
export { ForwardRef as ReactComponent };